import "./box.7ae5d7e6.js";


function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire305e"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire305e"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("jPxhr", function(module, exports) {

$parcel$export(module.exports, "formatPhoneNumber", () => $e6fc98820934cce0$export$842dcfa371c6bb83);
$parcel$export(module.exports, "formatPhone", () => $e6fc98820934cce0$export$10c09b2cff9813eb);
function $e6fc98820934cce0$export$842dcfa371c6bb83(inputField) {
    const phoneNumber = inputField.value.replace(/[^0-9]/g, ''); // clean the input
    const phoneNumberLength = phoneNumber.length;
    if (phoneNumberLength < 4) return phoneNumber; // no formatting for less than 4 digits
    if (phoneNumberLength < 7) return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6, 10)}`;
}
function $e6fc98820934cce0$export$10c09b2cff9813eb(phoneNumberString) {
    var cleaned = ('' + phoneNumberString).replace(/\D/g, '');
    var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) return '(' + match[1] + ') ' + match[2] + '-' + match[3];
    return null;
}

});


var $03cFT = parcelRequire("03cFT");

var $kcvY9 = parcelRequire("kcvY9");

var $cxph1 = parcelRequire("cxph1");

var $3w2h1 = parcelRequire("3w2h1");

var $cMcKP = parcelRequire("cMcKP");

var $jPxhr = parcelRequire("jPxhr");

var $dZ4hN = parcelRequire("dZ4hN");

var $i2HuG = parcelRequire("i2HuG");
"use strict";
window.Webflow ||= [];
window.Webflow.push(async ()=>{
    // MARK: - ELEMENTS
    const starOrderSection = document.getElementById("menuStartOrderSection");
    const itemsSection = document.getElementById("menuItemsSection");
    const bottomCategoriesSection = document.getElementById("menuCategoriesSection");
    const menuSubcategoriesSection = document.getElementById('menuSubcategoriesSection');
    const menuLabel = document.getElementById("menuHeaderLabel");
    const menuDescriptionLabel = document.getElementById("menuDescriptionLabel");
    const menuCategoryLabel = document.getElementById("menuCategoryLabel");
    const progressModal = document.getElementById('progressModal');
    const mobileCategoryButton = document.getElementById('mobileCategoryButton');
    const menuCategoriesDiv = document.getElementById('menuCategoriesDiv');
    var categories = [];
    var subcategories = [];
    var bottomCategories = [];
    var items = [];
    var selectedTopCategoryRow = 0;
    var selectedCategoryRow = 0;
    var selectedSubcategoryRow = 0;
    var selectedCategory;
    const locationObject = await (0, $kcvY9.LocationObject)();
    mobileCategoryButton.addEventListener('click', function() {
        showHideTables('flex', 'none', 'none');
        menuLabel.innerText = "LUPO MENU";
        menuDescriptionLabel.innerText = "Explore the entire Lupo menu";
        mobileCategoryButton.style.display = 'none';
    });
    // MARK: - START ORDER
    const menuDeliveryButton = document.getElementById('menuDeliveryButton');
    menuDeliveryButton.addEventListener('click', function() {
        sessionStorage.setItem('startDelivery', 'true');
        (0, $cxph1.goToNextPage)('/order');
    });
    const menuPickUpButton = document.getElementById('menuPickUpButton');
    menuPickUpButton.addEventListener('click', function() {
        sessionStorage.setItem('startDelivery', 'false');
        (0, $cxph1.goToNextPage)('/order');
    });
    // MARK: - ORDER DETAILS
    const orderDetailsDiv = document.getElementById('orderDetailsDiv');
    const checkOutButton = document.getElementById('checkOutButton');
    checkOutButton.addEventListener('click', function() {
        const currentUser = (0, $03cFT.default).User.current();
        if (currentUser != null) {
            const orderCheck = currentUser.get('orderCheck');
            if (orderCheck != null) {
                const checks = orderCheck.checks;
                if (checks != null) {
                    const check = checks[0];
                    const selections = check.selections;
                    if (selections.length > 0) (0, $cxph1.goToNextPage)('/box');
                    else alert('Add items to check out');
                } else alert('Add items to check out');
            } else alert('Add items to check out');
        }
    });
    const changeLocationButton = document.getElementById('changeLocationButton');
    changeLocationButton.addEventListener('click', function() {
        (0, $cxph1.goToNextPage)('/order');
    });
    const locationLabel = document.getElementById('locationLabel');
    const changeStoreButton = document.getElementById('changeStoreButton');
    changeStoreButton.addEventListener('click', function() {
        (0, $cxph1.goToNextPage)('/locations');
    });
    const storeLabel = document.getElementById('storeLabel');
    const phoneNumberButton = document.getElementById('phoneNumberButton');
    phoneNumberButton.addEventListener('click', function() {
        const location = JSON.parse(localStorage.getItem('location'));
        document.location.href = "tel:" + location.phone;
    });
    const pickUpBox = document.getElementById('pickUpBox');
    const pickUpIcon = document.getElementById('pickUpIcon');
    pickUpBox.addEventListener('click', function() {
        sessionStorage.setItem('deliveryBool', 'false');
        setUpOrderDetails();
        deliveryIcon.src = 'https://cdn.prod.website-files.com/674a9e2494fe039046e5bde6/675a12ce243a44d1eee4ad81_radio-button.png';
        setOrderDetails();
    });
    const deliveryBox = document.getElementById('deliveryBox');
    const deliveryIcon = document.getElementById('deliveryIcon');
    deliveryBox.addEventListener('click', function() {
        const deliveryAddress = JSON.parse(sessionStorage.getItem('deliveryAddress'));
        sessionStorage.setItem('deliveryBool', 'true');
        if (deliveryAddress != null) {
            setUpOrderDetails();
            pickUpIcon.src = 'https://cdn.prod.website-files.com/674a9e2494fe039046e5bde6/675a12ce243a44d1eee4ad81_radio-button.png';
            setOrderDetails();
        } else (0, $cxph1.goToNextPage)('/order');
    });
    const nowBox = document.getElementById('nowBox');
    const nowIcon = document.getElementById('nowIcon');
    nowBox.addEventListener('click', function() {
        sessionStorage.removeItem('futureDate');
        setOrderTimeDisplay();
    });
    const laterBox = document.getElementById('laterBox');
    const laterIcon = document.getElementById('laterIcon');
    laterBox.addEventListener('click', function() {
        dateModal.style.display = 'flex';
        initializeDatePicker();
    });
    const orderTimeButton = document.getElementById('orderTimeButton');
    function setUpOrderDetails() {
        starOrderSection.style.display = 'block';
        var deliveryBool = JSON.parse(sessionStorage.getItem('deliveryBool'));
        const deliveryAddress = JSON.parse(sessionStorage.getItem('deliveryAddress'));
        const pickupAddress = JSON.parse(sessionStorage.getItem('pickupAddress'));
        const location = JSON.parse(localStorage.getItem('location'));
        if (deliveryBool != null) {
            orderDetailsDiv.style.display = 'flex';
            starOrderSection.style.display = 'none';
            if (deliveryBool) {
                if (deliveryAddress != null) {
                    const address = deliveryAddress.addressLabel.toUpperCase();
                    const city = deliveryAddress.city.toUpperCase();
                    const stateCode = deliveryAddress.stateCode.toUpperCase();
                    const postalCode = deliveryAddress.postalCode.toUpperCase();
                    locationLabel.innerText = address + '\n' + city + ', ' + stateCode + ' ' + postalCode;
                    storeLabel.innerText = location.city.toUpperCase();
                    phoneNumberButton.innerText = (0, $jPxhr.formatPhone)(location.phone);
                    deliveryIcon.src = 'https://cdn.prod.website-files.com/69844dfbb2540a64ede3d866/69844dfbb2540a64ede3d8bd_6471bc91943c57da4b62374c873a7626_radio-button-selected.png';
                } else {
                    sessionStorage.setItem('deliveryBool', 'false');
                    if (location != null) {
                        locationLabel.innerText = location.zipcode;
                        storeLabel.innerText = location.city.toUpperCase();
                        phoneNumberButton.innerText = (0, $jPxhr.formatPhone)(location.phone);
                        pickUpIcon.src = 'https://cdn.prod.website-files.com/69844dfbb2540a64ede3d866/69844dfbb2540a64ede3d8bd_6471bc91943c57da4b62374c873a7626_radio-button-selected.png';
                    }
                }
            } else if (location != null) {
                locationLabel.innerText = location.zipcode; // pickupAddress.postalCode;
                storeLabel.innerText = location.city.toUpperCase();
                phoneNumberButton.innerText = (0, $jPxhr.formatPhone)(location.phone);
                pickUpIcon.src = 'https://cdn.prod.website-files.com/69844dfbb2540a64ede3d866/69844dfbb2540a64ede3d8bd_6471bc91943c57da4b62374c873a7626_radio-button-selected.png';
            }
        }
        setOrderTimeDisplay();
    }
    function setOrderTimeDisplay() {
        // Set up the order timing
        const futureDateString = sessionStorage.getItem('futureDate');
        if (futureDateString != null) {
            const futureDate = new Date(futureDateString);
            laterIcon.src = 'https://cdn.prod.website-files.com/69844dfbb2540a64ede3d866/69844dfbb2540a64ede3d8bd_6471bc91943c57da4b62374c873a7626_radio-button-selected.png';
            nowIcon.src = 'https://cdn.prod.website-files.com/674a9e2494fe039046e5bde6/675a12ce243a44d1eee4ad81_radio-button.png';
            orderTimeButton.style.display = 'block';
            const formattedDate = futureDate.toLocaleDateString('en-US', {
                weekday: 'long',
                month: 'short',
                day: 'numeric'
            });
            const options = {
                hour: '2-digit',
                minute: '2-digit',
                hour12: true
            };
            const hourString = futureDate.toLocaleString('en-US', options);
            orderTimeButton.innerText = formattedDate + ' - ' + hourString;
        } else {
            nowIcon.src = 'https://cdn.prod.website-files.com/69844dfbb2540a64ede3d866/69844dfbb2540a64ede3d8bd_6471bc91943c57da4b62374c873a7626_radio-button-selected.png';
            laterIcon.src = 'https://cdn.prod.website-files.com/674a9e2494fe039046e5bde6/675a12ce243a44d1eee4ad81_radio-button.png';
            orderTimeButton.style.display = 'none';
        }
    }
    function setOrderDetails() {
        const deliveryBool = JSON.parse(sessionStorage.getItem('deliveryBool'));
        const deliveryAddress = JSON.parse(sessionStorage.getItem('deliveryAddress'));
        const location = JSON.parse(localStorage.getItem('location'));
        const detailsOrderTypeLabel = document.getElementById('detailsOrderTypeLabel');
        const detailsTopLabel = document.getElementById('detailsTopLabel');
        const detailsAddressLabel = document.getElementById('detailsAddressLabel');
        const detailsCityLabel = document.getElementById('detailsCityLabel');
        const navOrderDetailsButton = document.getElementById('navOrderDetailsButton');
        if (deliveryBool) {
            detailsOrderTypeLabel.innerText = 'DELIVERY';
            detailsTopLabel.innerText = 'DELIVERY ADDRESS';
            detailsAddressLabel.innerText = deliveryAddress.addressLabel.toUpperCase();
            detailsCityLabel.innerText = deliveryAddress.city.toUpperCase() + ', ' + deliveryAddress.stateCode + ' ' + deliveryAddress.postalCode;
            navOrderDetailsButton.innerText = 'DELIVER TO:\n' + deliveryAddress.addressLabel.toUpperCase();
        } else {
            detailsOrderTypeLabel.innerText = 'PICK UP';
            detailsTopLabel.innerText = 'PICK UP ADDRESS';
            detailsAddressLabel.innerText = location.address.toUpperCase();
            detailsCityLabel.innerText = location.city.toUpperCase() + ', ' + location.state + ' ' + location.zipcode;
            navOrderDetailsButton.innerText = 'PICK UP AT:\n' + location.city.toUpperCase();
        }
    }
    setUpOrderDetails();
    // MARK: - FUTURE ORDER
    const dateModal = document.getElementById('dateModal');
    const orderDatePicker = document.getElementById('orderDatePicker');
    const orderTimePicker = document.getElementById('orderTimePicker');
    const chooseTimeButton = document.getElementById('chooseTimeButton');
    const orderSchedule = JSON.parse(localStorage.getItem('toastOrderSchedule'));
    var datePicker;
    var timePicker;
    function initializeDatePicker() {
        //const startDate = new Date()
        //const futureDate = sessionStorage.getItem('futureDate');
        //if (futureDate != null) {
        //startDate = new Date(futureDate);
        //}
        const now = new Date();
        var minimumDate = new Date(now);
        minimumDate.setMinutes(minimumDate.getMinutes() + 90);
        const closeDate = (0, $cMcKP.getCloseTime)(minimumDate);
        if (minimumDate > closeDate) {
            const nextDay = new Date(now);
            nextDay.setDate(nextDay.getDate() + 1);
            minimumDate = nextDay;
        }
        const maximumDate = new Date(minimumDate);
        maximumDate.setDate(maximumDate.getDate() + 14);
        //today.setMinutes(today.getMinutes() + 60);
        datePicker = (0, $dZ4hN.default)(orderDatePicker, {
            dateFormat: "l, M d",
            defaultDate: minimumDate,
            minDate: minimumDate,
            maxDate: maximumDate,
            onDayCreate: function(dObj, dStr, fp, dayElem) {
                if (dayElem.classList.contains("selected")) dayElem.style.backgroundColor = '#000000'; // Change the background color to red for selected dates
                else dayElem.style.backgroundColor = "initial"; // Reset the background color for non-selected dates
            },
            onChange: function(selectedDates, dateStr, instance) {
                const selectedDate = selectedDates[0];
                setUpTimePicker(selectedDate);
            }
        });
        setUpTimePicker(minimumDate);
    }
    function setUpTimePicker(startDate) {
        var minimumTime = new Date(startDate);
        const startDateToday = isToday(minimumTime);
        if (startDateToday) {
            const openDate = (0, $cMcKP.getOpenTime)(minimumTime);
            openDate.setMinutes(openDate.getMinutes() + 60);
            if (minimumTime < openDate) minimumTime = openDate;
        } else {
            // Add 90 minutes to the opening time
            minimumTime = (0, $cMcKP.getOpenTime)(minimumTime);
            minimumTime.setMinutes(minimumTime.getMinutes() + 60);
        }
        const maximumTime = (0, $cMcKP.getCloseTime)(startDate);
        timePicker = (0, $dZ4hN.default)(orderTimePicker, {
            enableTime: true,
            noCalendar: true,
            allowInput: false,
            dateFormat: "h:i K",
            defaultDate: minimumTime,
            minTime: minimumTime,
            maxTime: maximumTime
        });
    }
    function isToday(dateToCheck) {
        const today = new Date();
        const todayString = today.toDateString();
        const dateString = dateToCheck.toDateString();
        return todayString === dateString;
    }
    chooseTimeButton.addEventListener('click', async function() {
        progressModal.style.display = 'flex';
        const selectedTime = timePicker.selectedDates[0];
        const open = await (0, $cMcKP.toastStoreOpen)(selectedTime);
        if (open == true) {
            sessionStorage.setItem('futureDate', selectedTime.toISOString());
            setOrderTimeDisplay();
            dateModal.style.display = 'none';
        } else alert('Store will be closed please try another time or day');
        progressModal.style.display = 'none';
    });
    // MARK: - POP STATE
    window.addEventListener("popstate", function(event) {
        const state = event.state;
        if (state) {
            const categoryTable = state.categoryTable;
            const catergoryIndex = state.catergoryIndex;
            if (categoryTable == 'top') handleSelectedTopCategory(catergoryIndex);
            else {
                const subgroup = state.subgroup;
                if (subgroup == "subgroup") handleSelectedSubcategory(catergoryIndex);
                else handleSelectedBottomCategory(catergoryIndex);
            }
        } else handleSelectedTopCategory(0);
    });
    function checkPromoCategory() {
        const category = JSON.parse(sessionStorage.getItem('category'));
        if (category != null) {
            const categoryName = category.name.replaceAll(' ', '').toLowerCase().replace('/', '-');
            handleSelectCategoryName(categoryName);
            const pushState = {
                id: category.guid,
                categoryName: categoryName,
                categoryTable: 'top'
            };
            history.pushState(pushState, categoryName, 'menu?category=' + categoryName.replaceAll(' ', '').toLowerCase().replace('/', '-'));
            sessionStorage.removeItem('category');
        }
    }
    function handleCategoryUrl() {
        const urlParams = new URLSearchParams(window.location.search);
        const categoryName = urlParams.get('category');
        handleSelectCategoryName(categoryName);
    }
    function handleSelectCategoryName(categoryName) {
        if (categoryName != null) {
            if (categoryName == 'viewall') handleSelectedTopCategory(0);
            else if (categoryName == 'sandwiches') {
                let index = categories.findIndex((item)=>item.name.replaceAll(' ', '').toLowerCase().replace('/', '-') === categoryName);
                handleSelectedTopCategory(index);
            } else {
                let index = bottomCategories.findIndex((item)=>item.name.replaceAll(' ', '').toLowerCase().replace('/', '-') === categoryName);
                handleSelectedBottomCategory(index);
            }
        }
    }
    // MARK: - LOADING
    var stocks = [];
    async function loadToastMenus() {
        const viewAll = {
            name: 'View All'
        };
        categories.push(viewAll);
        progressModal.style.display = 'flex';
        const toastGuid = locationObject.get('guid');
        const menu = sessionStorage.getItem("toastMenus");
        if (menu != null) {
            var toastMenuObject = {
                "menus": JSON.parse(menu)
            };
            setUpLoad(toastMenuObject, toastGuid);
            progressModal.style.display = 'none';
            return;
        }
        try {
            const parseMenu = await (0, $03cFT.default).Cloud.run('loadToastMenu', {
                'restaurantGuid': toastGuid
            });
            const toastMenuObject = parseMenu.get('object');
            (0, $3w2h1.storeMenuData)(toastMenuObject);
            setUpLoad(toastMenuObject, toastGuid);
        } catch (e) {
            alert(e.message);
        }
        progressModal.style.display = 'none';
    }
    async function setUpLoad(toastMenuObject, toastGuid) {
        const availableMenus = (0, $3w2h1.filterAvailability)(toastMenuObject.menus);
        const menus = (0, $3w2h1.filterVisibility)(availableMenus);
        for (const menu of menus){
            console.log("Menu " + menu.name);
            const groups = (0, $3w2h1.filterVisibility)(menu.menuGroups);
            for (const group of groups){
                console.log("Category " + group.name);
                categories.push(group);
                const moreGroups = group.menuGroups;
                if (moreGroups.length > 0) {
                    let filteredGroups = (0, $3w2h1.filterVisibility)(moreGroups);
                    bottomCategories = bottomCategories.concat(filteredGroups);
                } else bottomCategories.push(group);
            }
        }
        const stock = await (0, $03cFT.default).Cloud.run('loadToastStock', {
            'restaurantGuid': toastGuid
        });
        stocks = stock.get('objects');
        setUpCategoryTopCollection();
        showHideTables('flex', 'none', 'none');
        setUpCategoryBottomTable();
        menuCategoriesDiv.style.display = 'flex';
        checkPromoCategory();
        handleCategoryUrl();
    }
    // MARK: - TOP CATEGORIES
    function setUpCategoryTopCollection() {
        const categoryCell = document.querySelector('[category="cell"]');
        const categoryParent = categoryCell.parentNode;
        const categoryCells = [
            ...document.querySelectorAll('[category="cell"]')
        ];
        for(let i = 0; i < categories.length; i++){
            const newCategoryCell = i === 0 ? categoryCells[0] : categoryCells[0].cloneNode(true);
            const title = newCategoryCell.querySelector('[category="name"]');
            title.innerText = categories[i].name.toUpperCase().replace(" ", "\n");
            categoryParent.appendChild(newCategoryCell);
            title.addEventListener('click', ()=>{
                const category = categories[i];
                const categoryName = category.name;
                const pushState = {
                    id: category.guid,
                    categoryName: categoryName,
                    categoryTable: 'top',
                    catergoryIndex: i
                };
                history.pushState(pushState, categoryName, 'menu?category=' + categoryName.replaceAll(' ', '').toLowerCase().replace('/', '-'));
                handleSelectedTopCategory(i);
            });
        }
    }
    function handleSelectedTopCategory(index) {
        selectedTopCategoryRow = index;
        const category = categories[selectedTopCategoryRow];
        updatePageTItle(category.name);
        if (selectedTopCategoryRow == 0) {
            showHideTables('flex', 'none', 'none');
            menuLabel.innerText = "LUPO MENU";
            menuDescriptionLabel.innerText = "Explore the entire Lupo menu";
        } else {
            const moreGroups = category.menuGroups;
            if (moreGroups.length > 0) {
                showHideTables('none', 'flex', 'none');
                setMenuTitles(category);
                subcategories = moreGroups;
                setUpSubcategoryBottomTable();
            } else {
                const category = categories[selectedTopCategoryRow];
                showHideTables('none', 'none', 'flex');
                setMenuTitles(category);
                setUpItemsTable(category);
            }
        }
    }
    function showHideTables(showCategories, showSubcategories, showItems) {
        bottomCategoriesSection.style.display = showCategories;
        menuSubcategoriesSection.style.display = showSubcategories;
        itemsSection.style.display = showItems;
    }
    // MARK: - BOTTOM CATEGORIES
    function setUpCategoryBottomTable() {
        if ((0, $i2HuG.isMobileDevice)() == true) mobileCategoryButton.style.display = 'none';
        const categoryCell = document.querySelector('[categories="cell"]');
        const categoryParent = categoryCell.parentNode;
        const categoryCells = [
            ...document.querySelectorAll('[categories="cell"]')
        ];
        for(let i = 0; i < bottomCategories.length; i++){
            const newCategoryCell = i === 0 ? categoryCells[0] : categoryCells[0].cloneNode(true);
            const title = newCategoryCell.querySelector('[categories="name"]');
            title.innerText = bottomCategories[i].name.toUpperCase();
            const image = newCategoryCell.querySelector('[categories="image"]');
            const imageUrl = bottomCategories[i].image;
            if (imageUrl != null) image.src = imageUrl;
            else image.src = "../images/placeholder.png";
            image.style.display = "none";
            newCategoryCell.addEventListener('touchstart', function(event) {
                title.style.color = 'white';
                newCategoryCell.style.backgroundColor = '#000000';
            });
            newCategoryCell.addEventListener('touchend', function(event) {
                title.style.color = '#000000';
                newCategoryCell.style.backgroundColor = 'white';
            });
            newCategoryCell.addEventListener('mouseover', function() {
                title.style.color = 'white';
                newCategoryCell.style.backgroundColor = '#000000';
            });
            newCategoryCell.addEventListener('mouseout', function() {
                title.style.color = '#000000';
                newCategoryCell.style.backgroundColor = 'white';
            });
            newCategoryCell.addEventListener('click', ()=>{
                const category = bottomCategories[i];
                const categoryName = category.name;
                const pushState = {
                    categoryTable: 'bottom',
                    subgroup: 'category',
                    catergoryIndex: i
                };
                history.pushState(pushState, categoryName, 'menu?category=' + categoryName.replaceAll(' ', '').toLowerCase().replace('/', '-'));
                handleSelectedBottomCategory(i);
            });
            categoryParent.appendChild(newCategoryCell);
        }
    }
    function handleSelectedBottomCategory(index) {
        selectedCategoryRow = index;
        const category = bottomCategories[selectedCategoryRow];
        updatePageTItle(category.name);
        setMenuTitles(category);
        showHideTables('none', 'none', 'flex');
        setUpItemsTable(category);
    }
    function setMenuTitles(category) {
        menuLabel.innerText = "LUPO " + category.name.toUpperCase();
        menuDescriptionLabel.innerText = category.description;
        menuCategoryLabel.innerText = category.name.toUpperCase();
    }
    function clearCellItems(categoryCells) {
        categoryCells.forEach((cell, index)=>{
            if (index > 0) cell.parentNode.removeChild(cell);
        });
    }
    // MARK: - SUB CATEGORIES
    function setUpSubcategoryBottomTable() {
        if ((0, $i2HuG.isMobileDevice)() == true) mobileCategoryButton.style.display = 'none';
        const categoryCell = document.querySelector('[subcategories="cell"]');
        const categoryParent = categoryCell.parentNode;
        const categoryCells = [
            ...document.querySelectorAll('[subcategories="cell"]')
        ];
        clearCellItems(categoryCells);
        for(let i = 0; i < subcategories.length; i++){
            const newCategoryCell = i === 0 ? categoryCells[0] : categoryCells[0].cloneNode(true);
            const title = newCategoryCell.querySelector('[subcategories="name"]');
            title.innerText = subcategories[i].name.toUpperCase();
            const image = newCategoryCell.querySelector('[subcategories="image"]');
            const imageUrl = subcategories[i].image;
            if (imageUrl != null) image.src = imageUrl;
            else image.src = "../images/placeholder.png";
            image.style.display = "none";
            newCategoryCell.addEventListener('touchstart', function(event) {
                title.style.color = 'white';
                newCategoryCell.style.backgroundColor = '#000000';
            });
            newCategoryCell.addEventListener('touchend', function(event) {
                title.style.color = '#000000';
                newCategoryCell.style.backgroundColor = 'white';
            });
            newCategoryCell.addEventListener('mouseover', function() {
                title.style.color = 'white';
                newCategoryCell.style.backgroundColor = '#000000';
            });
            newCategoryCell.addEventListener('mouseout', function() {
                title.style.color = '#000000';
                newCategoryCell.style.backgroundColor = 'white';
            });
            newCategoryCell.addEventListener('click', (event)=>{
                event.stopPropagation();
                // Your code here
                const category = subcategories[i];
                const categoryName = category.name;
                const pushState = {
                    categoryTable: 'bottom',
                    subgroup: 'subgroup',
                    catergoryIndex: i
                };
                history.pushState(pushState, categoryName, 'menu?category=' + categoryName.replaceAll(' ', '').toLowerCase().replace('/', '-'));
                handleSelectedSubcategory(i);
            });
            categoryParent.appendChild(newCategoryCell);
        }
    }
    function updatePageTItle(categoryName) {
        var title = categoryName;
        if (locationObject != null) {
            const storename = locationObject.get('storename');
            title += ' | ' + storename;
        }
        document.title = title;
    }
    function handleSelectedSubcategory(index) {
        selectedSubcategoryRow = index;
        const category = subcategories[selectedSubcategoryRow];
        updatePageTItle(category.name);
        setMenuTitles(category);
        showHideTables('none', 'none', 'flex');
        setUpItemsTable(category);
    }
    // MARK: - FOOD ITEMS
    function setUpItemsTable(category) {
        if ((0, $i2HuG.isMobileDevice)() == true) mobileCategoryButton.style.display = 'block';
        selectedCategory = category;
        items = (0, $3w2h1.filterVisibility)(category.menuItems);
        const itemCell = document.querySelector('[items="cell"]');
        const itemParent = itemCell.parentNode;
        const itemCells = [
            ...document.querySelectorAll('[items="cell"]')
        ];
        clearCellItems(itemCells);
        for(let i = 0; i < items.length; i++){
            const newItemCell = i === 0 ? itemCells[0] : itemCells[0].cloneNode(true);
            const title = newItemCell.querySelector('[items="name"]');
            title.innerText = items[i].name.toUpperCase();
            const image = newItemCell.querySelector('[items="image"]');
            const imageUrl = items[i].image;
            if (imageUrl != null) image.src = imageUrl;
            else image.src = "../images/placeholder.png";
            const orderButton = newItemCell.querySelector('[items="order"]');
            image.addEventListener('click', ()=>{
                itemSelected(i);
            });
            orderButton.addEventListener('click', ()=>{
                itemSelected(i);
            });
            title.addEventListener('click', ()=>{
                itemSelected(i);
            });
            itemParent.appendChild(newItemCell);
        }
    }
    function itemSelected(i) {
        const item = items[i];
        const stock = (0, $3w2h1.getStockStatus)(item.guid, stocks);
        let status = stock.status;
        if (status == "OUT_OF_STOCK") alert(item.name + ' is currently out of stock');
        else {
            sessionStorage.setItem('category', JSON.stringify(selectedCategory));
            sessionStorage.setItem('menuItem', JSON.stringify(item));
            (0, $cxph1.goToNextPage)('/item');
        }
    }
    loadToastMenus();
});


//# sourceMappingURL=menu.7b36ac15.js.map
